<template>
  <span class="store-status" :class="statusClass">
    <icon :name="iconName" class="store-icon" />
    {{ statusText }}
  </span>
</template>

<script>
import 'vue-awesome/icons/eye'
import 'vue-awesome/icons/eye-slash'
import 'vue-awesome/icons/ban'
import Icon from 'vue-awesome/components/Icon'

export default {
  name: 'StoreStatus',
  components: {
    Icon
  },
  props: {
    virtual_store: {
      type: Number,
      required: true,
      validator: value => [0, 1].includes(value)
    },
    hidden_store: {
      type: Number,
      required: true,
      validator: value => [0, 1].includes(value)
    }
  },
  computed: {
    statusText () {
      if (this.virtual_store === 0) {
        return 'Desativada'
      }
      if (this.hidden_store === 1) {
        return 'Ativa oculta'
      }
      return 'Ativa e visível'
    },
    iconName () {
      if (this.virtual_store === 0) {
        return 'ban'
      }
      if (this.hidden_store === 1) {
        return 'eye-slash'
      }
      return 'eye'
    },
    statusClass () {
      if (this.virtual_store === 0) {
        return 'status-disabled'
      }
      if (this.hidden_store === 1) {
        return 'status-hidden'
      }
      return 'status-active'
    }
  }
}
</script>

<style lang="scss" scoped>
.store-status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.store-icon {
  width: 16px;
  height: 16px;
}

.status-active {
  color: #26A65B;
}

.status-hidden {
  color: #F39C12;
}

.status-disabled {
  color: #E74C3C;
}
</style>
